/* Échiquier Boutique — encart boutique au milieu des articles du blog (Claude). */
(function () {
  'use strict';
  function run() {
    if (!document.body.classList.contains('template-article')) { return; }
    var body = document.querySelector('[itemprop="articleBody"]');
    if (!body || body.querySelector('.eb-article-cta')) { return; }
    var heads = body.querySelectorAll('h2');
    if (heads.length < 4) { return; }
    var fr = (document.documentElement.lang || 'fr').indexOf('fr') === 0;
    var root = fr ? '' : '/en';
    var box = document.createElement('aside');
    box.className = 'eb-article-cta';
    box.innerHTML = fr
      ? '<p class="eb-article-cta__title">Envie de jouer sur un bel échiquier ?</p><p class="eb-article-cta__text">Nos jeux sont choisis un par un. Préparation habituelle : 2 à 5 jours ouvrés (voir la fiche produit).</p><ul class="eb-article-cta__links"><li><a href="/collections/jeux-echecs-bois">Jeux d’échecs en bois</a></li><li><a class="eb-alt" href="/collections/meilleures-ventes">Meilleures ventes</a></li><li><a class="eb-alt" href="/collections/jeux-echecs-electroniques">Jeux électroniques</a></li></ul>'
      : '<p class="eb-article-cta__title">Looking for a fine chess set?</p><p class="eb-article-cta__text">Our sets are hand-picked. Usual preparation time: 2 to 5 working days (see the product page).</p><ul class="eb-article-cta__links"><li><a href="/en/collections/jeux-echecs-bois">Wooden chess sets</a></li><li><a class="eb-alt" href="/en/collections/meilleures-ventes">Best sellers</a></li><li><a class="eb-alt" href="/en/collections/jeux-echecs-electroniques">Electronic chess</a></li></ul>';
    var target = heads[2];
    target.parentNode.insertBefore(box, target);
  }
  if (document.readyState !== 'loading') { setTimeout(run, 0); } else { document.addEventListener('DOMContentLoaded', function () { setTimeout(run, 0); }); }
})();

/* 15/10/2026 : code BIENVENUE5 désactivé -> la barre d'annonce ne doit plus l'afficher (le texte d'origine est dans sections/header.liquid). */
(function () {
  function fix() {
    var a = document.querySelector('#shopify-section-header .announcement-bar');
    if (a && /BIENVENUE5|-\s?5\s?%/.test(a.textContent)) {
      a.innerHTML = '<b>Livraison offerte</b>&nbsp;dès 99 € en France · Retours sous 14 jours';
    }
  }
  if (document.readyState !== 'loading') { fix(); } else { document.addEventListener('DOMContentLoaded', fix); }
})();
